/** WebGL housekeeping shared by every map on these pages. */

import { useEffect } from 'react';

/** Gives the WebGL contexts of maps that left the page back to the browser. deck.gl
 *  leaves them to the garbage collector, and Chrome drops its oldest context, the main
 *  map's, once a page holds 16: a few visits to Scenario Comparison, five maps each,
 *  blanked the main map. `key` is the DeckGL key, whose change also replaces the canvas. */
export function useReleaseWebGL(ref, key) {
  useEffect(() => {
    const canvases = ref.current ? [...ref.current.querySelectorAll('canvas')] : [];
    return () => {
      setTimeout(() => {
        for (const c of canvases) {
          if (c.isConnected) continue; // still on the page: a StrictMode rehearsal
          const gl = c.getContext('webgl2') || c.getContext('webgl');
          if (gl && !gl.isContextLost()) gl.getExtension('WEBGL_lose_context')?.loseContext();
        }
      }, 0);
    };
  }, [ref, key]);
}
